import { Injectable } from '@angular/core'
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http'
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class artPieceService {
  serverAddress = environment.item_master + '/artPiece';
  constructor(private http: HttpClient) {
  }
  setUserAuth() {
    let token = localStorage.getItem("token")
    const headers = new HttpHeaders()
      .set('Authorization', token)
    return headers
  }

  setUserAuthWithLoader() {
    let token = localStorage.getItem("token")
    const headers = new HttpHeaders()
      .set('Authorization', token)
      .set('X-Enable-Loader', 'true')
    return headers
  }

  getAllitems(pagination: { startRow?: number, endRow?: number, filterModel?: any, isArchive?: boolean }) {
    // Set defaults in the service method
    const startRow = pagination.startRow ?? 0
    const endRow = pagination.endRow ?? 100
    const filterModel = pagination.filterModel

    let params = new HttpParams()
      .set('startRow', startRow.toString())
      .set('endRow', endRow.toString())
      .set('filterModel', JSON.stringify(filterModel))

    if (pagination.isArchive) {
      params = params.set('isArchive', 'true');
    }

    return this.http.get(`${this.serverAddress}/getAllitems`, {
      headers: this.setUserAuthWithLoader(),
      params
    });
  }

  updateArchive(data: any) {
    return this.http.post(`${this.serverAddress}/updateArchive/`, { data }, { headers: this.setUserAuth() });
  }

  deleteArtPieces(ids: number[]) {
    return this.http.post(`${this.serverAddress}/deleteArtPieces`, { ids }, { headers: this.setUserAuth() });
  }

  checkDeleteEligibility(ids: number[]) {
    return this.http.post(`${this.serverAddress}/checkDeleteEligibility`, { ids }, { headers: this.setUserAuth() });
  }

  getViewlayout(grid_id) {
    return this.http.get(`${this.serverAddress}/getViewlayout/${grid_id}`, { headers: this.setUserAuth() })
  }
  createItem(data) {
    return this.http.post(this.serverAddress + '/createItem', data, { headers: this.setUserAuth() })
  }
  getArtPiece(id: number) {
    return this.http.get(`${this.serverAddress}/getArtPiece/${id}`, { headers: this.setUserAuth() });
  }
  setPrimaryImage(oldUuid: string, newUuid: string) {
    return this.http.post(`${this.serverAddress}/setPrimaryImage`, { oldUuid, newUuid }, { headers: this.setUserAuth() });
  }
  addAttachment(artPieceId: number, attachmentData: any) {
    return this.http.post(`${this.serverAddress}/addAttachment/${artPieceId}`, attachmentData, { headers: this.setUserAuth() });
  }
  updateArtPiece(data: any) {
    return this.http.post(`${this.serverAddress}/updateArtPiece/`, data, { headers: this.setUserAuth() });
  }
  getProductCategories() {
    return this.http.get(`${this.serverAddress}/getProductCategories`, { headers: this.setUserAuth() })
  }
  deleteAttachment(uuid: string) {
    return this.http.delete(`${this.serverAddress}/deleteAttachment/${uuid}`, { headers: this.setUserAuth() });
  }
}

